import { render, staticRenderFns } from "./CardPromo.vue?vue&type=template&id=66412470&"
import script from "./CardPromo.vue?vue&type=script&lang=js&"
export * from "./CardPromo.vue?vue&type=script&lang=js&"
import style0 from "./CardPromo.vue?vue&type=style&index=0&id=66412470&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports